import React from 'react';

/* Common */
import { Button } from '~/components/common';

export default function ConversionFlowSubmit({
    flow,
    handleClose = () => { },
    theme = 'primary',
    title = flow?.form?.buttonLabel,
    className = 'mt-2',
    isLoading,
    attributes = {
        type: 'submit'
    },
    ...passProps
}) {
    const activeStep = flow?.steps.find((step) => step.active);

    return (
        <Button
            className={className}
            theme={theme}
            title={title}
            attributes={attributes}
            disabled={isLoading}
            loading={isLoading}
            {...passProps}
            onClick={(e) => {
                if (activeStep?.last) {
                    e.preventDefault();
                    handleClose();
                }
            }}
        />
    )
}
